import { Box, BoxProps } from "@chakra-ui/react";

/**
 * The `SectionTemplate` component is used as a wrapper for all the pages on the website to provide a default padding style
 */
export function SectionTemplate({
  color,
  bg,
  children,
  innerProps,
  rounded,
  py,
  px,
  ...rest
}: BoxProps & { innerProps?: BoxProps; rounded?: Boolean }) {
  const borderRadius: "none" | "20px" =
    rounded || bg !== "white" ? "none" : "20px";

  return (
    <Box
      as="section"
      {...{ color, bg, borderRadius }}
      py={
        py ?? {
          base: "30px",
          md: "50px",
        }
      }
      px={
        px ?? {
          base: "20px",
          md: "40px",
        }
      }
      pos={"relative"}
      zIndex={2}
      {...rest}
    >
      <Box mx="auto" maxW={{ base: "xl", md: "7xl" }} {...innerProps}>
        {children}
      </Box>
    </Box>
  );
}
